import 'js-loading-overlay';
export function showLoadingOverlay() {
  window.JsLoadingOverlay.show({
    spinnerIcon: 'ball-pulse',
    spinnerColor: '#2bb34d'
  });
}
export function hideLoadingOverlay() {
  window.JsLoadingOverlay.hide();
}